import React, { useMemo } from 'react';
import styles from './ProgressLine.module.scss';

interface Props {
  label?: string;
  percents?: number;
  step?: number;
  count?: number;
}

function ProgressLine(props: Props) {
  const { label, percents = -1, step = 1, count = 1 } = props;
  const percentage = useMemo(() => {
    if (percents > -1) return percents;
    return Math.round((step / count) * 100);
  }, [percents, step, count]);
  return (
    <div className={styles.container}>
      {!!label && <span className={styles.label}>{label}</span>}
      <div className={styles.line}>
        <div className={styles.progress} style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
}

export default ProgressLine;
